import AdvancedReportPage, { DefaultActionPanel } from "./AdvancedReportPage";
import ReportHeader from "./ReportHeader";
import ReportPage from "./ReportPage";

export const HITS_PER_PAGE = 20;

export const getReportParams = location => ({
  sort: location.query.sort,
  first: HITS_PER_PAGE,
  after: location.query.after,
  q: location.query.search_query
});

export { ReportHeader, ReportPage, AdvancedReportPage, DefaultActionPanel };
